import React, { useState, useRef } from 'react';
import { Typeahead } from 'react-bootstrap-typeahead';
import { toast } from 'react-toastify';

const CreateCloseups = ({
  currentPiece,
  artistInfo,
  instruments,
  accessMode,
  piecesInfo,
  pieceCloseups,
  onCreate,
  onDelete,
  onEdit,
  getAwsKey,
  isCreating,
  triggerGetPiece
}) => {
  const [state, setState] = useState({
    video_file: '',
    video: '',
    order: '',
    title: '',
    file: {},
    awsKeys: {},
    disableUpload: false,
    videoUploaded: false,
    isUploading: false,
    closeupInputEditOn: false,
    closeupInputOn: false,
    artist: [],
    instrument: null,
    showFollowing: false,
    CloseupToEdit: null,
  });

  const typeaheadRef = useRef();

  const onChangeSetToState = (stateKey) => (e) => {
    let updates = {
      [stateKey]: e.currentTarget.value.trim(),
    };
    if (['video_file'].includes(stateKey)) {
      updates.disableUpload = true;
    }
    setState(prev => ({ ...prev, ...updates }));
  };

  const clearForm = () => {
    setState({
      video_file: '',
      video: '',
      order: '',
      title: '',
      artist: [],
      file: {},
      awsKeys: {},
      disableUpload: false,
      videoUploaded: false,
      isUploading: false,
      members: null,
      instrument: null,
      closeupInputEditOn: false,
      closeupInputOn: false,
      CloseupToEdit: null,
    });

    try {
      document.getElementById('uploadPieceCloseup').value = null;
    } catch (e) { }

    if (typeaheadRef.current) {
      typeaheadRef.current.getInstance().clear();
    }
  };

  const onSubmit = async () => {
    const { video_file, title, member, instrument, artist, order } = state;
    const piece_id = currentPiece.id;
    const instrumentName = instrument[0] && instrument[0].name;

    await onCreate({
      piece_id,
      artist: artist[0].name,
      video: video_file,
      title,
      order,
      sequence: order,
      instrument: instrumentName,
    });

    clearForm();
  };

  const editCloseup = async () => {
    const { piece_id, artist, video, instrument, id, order } = state.CloseupToEdit;
    const instrumentName = instrument[0].name;

    await onEdit(
      { piece_id, artist: artist[0].name, order, video, id, instrument: instrumentName },
      pieceCloseups[state.showFollowing]
    );

    setState(prev => ({
      ...prev,
      video_file: '',
      video: '',
      order: '',
      file: {},
      awsKeys: {},
      disableUpload: false,
      videoUploaded: false,
      isUploading: false,
      title: '',
      members: null,
      instrument: null,
      showFollowing: false,
      closeupInputEditOn: false,
      closeupInputOn: false,
      CloseupToEdit: null,
    }));

    if (typeaheadRef.current) {
      typeaheadRef.current.getInstance().clear();
    }
    triggerGetPiece();
  };

  const onFileChange = async (eve) => {
    setState(prev => ({
      ...prev,
      videoUploaded: false,
      disableUpload: false,
    }));

    const file = eve.target.files[0];
    const fileName = file.name.replace(/ /g, '_');
    const awsKeys = await getAwsKey({ key: `pieces/closeups/videos/${fileName}` });

    setState(prev => ({
      ...prev,
      file,
      video_file: `${awsKeys.action}${awsKeys.key}`,
      awsKeys,
      disableUpload: true,
    }));

    if (state.CloseupToEdit) {
      let VideoFile = state.CloseupToEdit;
      VideoFile['video'] = `${awsKeys.action}${awsKeys.key}`;
      setState(prev => ({
        ...prev,
        CloseupToEdit: VideoFile,
      }));
    }
  };

  const uploadVideo = (label) => async (eve) => {
    eve.preventDefault();

    if (label === 'editCloseup') {
      if (Object.keys(state.awsKeys).length) {
        var form = document.getElementById('uploadCloseupsVideoEdit');
        var data = new FormData(form);
      }
    } else {
      if (Object.keys(state.awsKeys).length) {
        var form = document.getElementById('uploadCloseupsVideo');
        var data = new FormData(form);
      }
    }

    try {
      setState(prev => ({
        ...prev,
        isUploading: true,
      }));

      if (state.awsKeys.action) {
        await fetch(state.awsKeys.action, { method: 'POST', body: data });
        toast.success('Video uploaded successfully.');
      }

      setState(prev => ({
        ...prev,
        videoUploaded: true,
      }));

      if (label === 'editCloseup') {
        editCloseup();
      } else {
        onSubmit();
      }
    } catch (error) {
      toast.error('Something went wrong while uploading video.');
    }
  };

  const handleDelete = async (closeup) => {
    await onDelete(closeup);
  };

  const Show = (i) => {
    const CloseupToEditArray = pieceCloseups.filter((video, id) => {
      if (id === i) {
        return video;
      }
    });
    const CloseupObject = { ...CloseupToEditArray[0] };

    CloseupObject.artist = piecesInfo.members.filter(({ name }) => name === CloseupObject.artist);
    CloseupObject.instrument = piecesInfo.instruments.filter(({ name }) => name === CloseupObject.instrument);

    setState(prev => ({
      ...prev,
      showFollowing: i,
      CloseupToEdit: CloseupObject,
    }));
  };

  const handleStateChange = (key, val) => (e) => {
    e.stopPropagation();
    let updates = { [key]: val };
    if (['closeupInputEditOn', 'closeupInputOn'].includes(key)) {
      updates['video_file'] = '';
      updates['awsKeys'] = {};
    }
    setState(prev => ({ ...prev, ...updates }));
  };

  const handleEditStateChange = (key, value) => {
    let ArtistCloseup = state.CloseupToEdit;
    ArtistCloseup[key] = value;
    setState(prev => ({
      ...prev,
      CloseupToEdit: ArtistCloseup,
    }));
  };

  const getPieceCloseups = () => {
    const { awsKeys, disableUpload, closeupInputEditOn } = state;
    return pieceCloseups.map((closeup, i) => {
      return (
        <div className="instrument-list" key={closeup.id}>
          {accessMode === 'edit' && (
            <div className="row">
              <span
                style={{ display: 'inline-block', float: 'right', color: 'red' }}
                className="glyphicon glyphicon-remove-circle"
                aria-hidden="true"
                onClick={() => handleDelete(closeup)}
              />
              <span
                style={{ display: 'inline-block', float: 'right', marginRight: '10px', color: 'green' }}
                className="glyphicon glyphicon-edit"
                aria-hidden="true"
                onClick={() => Show(i)}
              />
            </div>
          )}
          {state.showFollowing === i && (
            <div>
              <div className="row">
                <div className="col-md-3">
                  <label>Artist</label>
                </div>
                <div className="col-md-9">
                  <Typeahead
                    onChange={(selected) => {
                      let ArtistCloseup = state.CloseupToEdit;
                      ArtistCloseup['artist'] = selected;
                      setState(prev => ({
                        ...prev,
                        CloseupToEdit: ArtistCloseup,
                      }));
                    }}
                    labelKey="name"
                    options={piecesInfo.members}
                    selected={state.CloseupToEdit.artist}
                    className={`form-group ${accessMode === 'view' ? 'disabled' : ''}`}
                    placeholder="Artist"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <label>Instrument</label>
                </div>
                <div className="col-md-9">
                  <Typeahead
                    onChange={(selected) => {
                      let CloseupInstrument = state.CloseupToEdit;
                      CloseupInstrument['instrument'] = selected;
                      setState(prev => ({
                        ...prev,
                        CloseupToEdit: CloseupInstrument,
                      }));
                    }}
                    ref={typeaheadRef}
                    labelKey="name"
                    options={instruments}
                    selected={state.CloseupToEdit.instrument}
                    className="form-group"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <label>Order</label>
                </div>
                <div className="col-md-9">
                  <input
                    name="order"
                    placeholder="Order"
                    type="number"
                    value={state.CloseupToEdit.order}
                    onChange={(e) => {
                      let ArtistCloseup = state.CloseupToEdit;
                      ArtistCloseup['order'] = Number(e.target.value);
                      setState(prev => ({
                        ...prev,
                        CloseupToEdit: ArtistCloseup,
                      }));
                    }}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <label>Video File</label>
                </div>
                <div className="col-md-9 radio-part">
                  <div className="currentFile">{state.CloseupToEdit.video}</div>

                  <div className="radio-selection row">
                    <div className="col-md-4">
                      <input
                        type="radio"
                        id="linkTypeVideoEdit"
                        name="videoTypeEdit"
                        checked={!closeupInputEditOn}
                        onChange={handleStateChange('closeupInputEditOn', false)}
                      />
                      &nbsp;
                      <label htmlFor="linkTypeVideoEdit">Link</label>
                    </div>
                    <div className="col-md-4">
                      <input
                        type="radio"
                        id="uploadTypeVideoEdit"
                        name="videoTypeEdit"
                        checked={closeupInputEditOn}
                        onChange={handleStateChange('closeupInputEditOn', true)}
                      />
                      &nbsp;
                      <label htmlFor="uploadTypeVideoEdit">Upload</label>
                    </div>
                  </div>

                  {closeupInputEditOn ? (
                    <form id="uploadCloseupsVideoEdit" method="post" encType="multipart/form-data">
                      <input type="hidden" name="key" value={awsKeys.key || 'NA'} />
                      <input type="hidden" name="acl" value={awsKeys.acl || 'NA'} />
                      <input type="hidden" name="X-Amz-Credential" value={awsKeys['x-amz-credential'] || 'NA'} />
                      <input type="hidden" name="X-Amz-Algorithm" value={awsKeys['x-amz-algorithm'] || 'NA'} />
                      <input type="hidden" name="X-Amz-Date" value={awsKeys['x-amz-date'] || 'NA'} />
                      <input type="hidden" name="Policy" value={awsKeys.policy || 'NA'} />
                      <input type="hidden" name="X-Amz-Signature" value={awsKeys['x-amz-signature'] || 'NA'} />
                      <input id="uploadPieceCloseup" type="file" name="file" onChange={onFileChange} />
                    </form>
                  ) : (
                    <input
                      name="video"
                      placeholder="Video File"
                      value={state.CloseupToEdit.video}
                      onChange={(e) => handleEditStateChange('video', e.target.value)}
                      className={`form-control ${accessMode === 'view' ? 'disabled' : ''}`}
                      parentClass="form-group"
                    />
                  )}
                </div>
              </div>
              <div className="editButtons">
                <button
                  type="submit"
                  name="submit"
                  className="cus-btn-primary btn-sm submitButton"
                  style={{ margin: '10px 10px 10px 10px' }}
                  onClick={uploadVideo('editCloseup')}
                >
                  {isCreating || state.isUploading ? <span className="spinner" /> : <span>Save</span>}
                </button>
                <button
                  type="button"
                  name="button"
                  className="cus-btn-danger btn-sm submitButton"
                  style={{ margin: '10px 10px 10px 10px' }}
                  onClick={() => {
                    setState(prev => ({
                      ...prev,
                      showFollowing: false,
                      CloseupToEdit: null,
                    }));
                  }}
                >
                  {isCreating || state.isUploading ? <span className="spinner" /> : <span>Cancel</span>}
                </button>
              </div>
              <hr />
            </div>
          )}
          {state.showFollowing !== i && (
            <div>
              <div className="row">
                <div className="col-md-3">
                  <label>Artist</label>
                </div>
                <div className="col-md-9">{closeup.artist}</div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <label>Instrument</label>
                </div>
                <div className="col-md-9">{closeup.instrument}</div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <label>Order</label>
                </div>
                <div className="col-md-9">{closeup.order}</div>
              </div>
              <div className="row">
                <div className="col-md-3">
                  <label>Video File</label>
                </div>
                <div className="col-md-9">{closeup.video}</div>
              </div>
              <hr />
            </div>
          )}
        </div>
      );
    });
  };

  const { awsKeys, disableUpload, closeupInputOn } = state;

  return (
    <section className="well create-instrument">
      {getPieceCloseups()}
      {accessMode === 'edit' && (
        <React.Fragment>
          <div className="row">
            <div className="col-md-3">
              <label>Artist</label>
            </div>
            <div className="col-md-9">
              <Typeahead
                onChange={(selected) => {
                  setState(prev => ({
                    ...prev,
                    artist: selected,
                  }));
                }}
                labelKey="name"
                options={piecesInfo.members}
                selected={state.artist}
                className={`form-group ${accessMode === 'view' ? 'disabled' : ''}`}
                placeholder="Artist"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-3">
              <label>Instrument</label>
            </div>
            <div className="col-md-9">
              <Typeahead
                onChange={(selected) => {
                  setState(prev => ({
                    ...prev,
                    instrument: selected,
                  }));
                }}
                ref={typeaheadRef}
                labelKey="name"
                options={instruments}
                selected={state.instrument}
                className="form-group"
                placeholder="Instrument"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <label>Order</label>
            </div>
            <div className="col-md-9">
              <input
                name="order"
                placeholder="Order"
                type="number"
                value={state.order}
                onChange={(e) => {
                  setState(prev => ({ ...prev, order: Number(e.target.value) }));
                }}
                className="form-control"
                parentClass="form-group"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <label>Video File</label>
            </div>

            <div className="col-md-9 radio-part">
              <div className="radio-selection row">
                <div className="col-md-4">
                  <input
                    type="radio"
                    id="linkTypeVideo"
                    name="videoType"
                    checked={!closeupInputOn}
                    onChange={handleStateChange('closeupInputOn', false)}
                  />
                  &nbsp;
                  <label htmlFor="linkTypeVideo">Link</label>
                </div>
                <div className="col-md-4">
                  <input
                    type="radio"
                    id="uploadTypeVideo"
                    name="videoType"
                    checked={closeupInputOn}
                    onChange={handleStateChange('closeupInputOn', true)}
                  />
                  &nbsp;
                  <label htmlFor="uploadTypeVideo">Upload</label>
                </div>
              </div>

              {closeupInputOn ? (
                <form id="uploadCloseupsVideo" method="post" encType="multipart/form-data">
                  <input type="hidden" name="key" value={awsKeys.key || 'NA'} />
                  <input type="hidden" name="acl" value={awsKeys.acl || 'NA'} />
                  <input type="hidden" name="X-Amz-Credential" value={awsKeys['x-amz-credential'] || 'NA'} />
                  <input type="hidden" name="X-Amz-Algorithm" value={awsKeys['x-amz-algorithm'] || 'NA'} />
                  <input type="hidden" name="X-Amz-Date" value={awsKeys['x-amz-date'] || 'NA'} />
                  <input type="hidden" name="Policy" value={awsKeys.policy || 'NA'} />
                  <input type="hidden" name="X-Amz-Signature" value={awsKeys['x-amz-signature'] || 'NA'} />
                  <input id="uploadPieceCloseup" type="file" name="file" onChange={onFileChange} />
                </form>
              ) : (
                <input
                  name="video"
                  placeholder="Video File"
                  value={state.video_file}
                  onChange={onChangeSetToState('video_file')}
                  className={`form-control ${accessMode === 'view' ? 'disabled' : ''}`}
                  parentClass="form-group"
                />
              )}
            </div>
          </div>
          <button
            type="submit"
            name="submit"
            className="cus-btn-primary btn-block btn-lg submitButton"
            onClick={uploadVideo('newCloseup')}
            disabled={isCreating || !(disableUpload && state.artist && state.instrument)}
          >
            {isCreating || state.isUploading ? <span className="spinner" /> : <span>Add Closeups</span>}
          </button>
        </React.Fragment>
      )}
    </section>
  );
};

export default CreateCloseups;
